import React, { memo } from "react"

import DefaultLayout from "~layouts/DefaultLayout"

import { MicrocopyProvider } from "~contexts/MicrocopyContext"
import { SessionProvider } from "~contexts/SessionContext"
import { CookiesProvider } from "react-cookie"

import Notification from "~components/Header/Notification"
import Header from "~components/Header"
import Head from "./Head"

import * as style from "./FramedLayout.module.scss"

const FramedLayout = ({
  children, showHeader, showSearch, microcopy,
}) => (
  <DefaultLayout>
    <CookiesProvider>
      <SessionProvider>
        <Head microcopy={microcopy} />
        <MicrocopyProvider microcopy={microcopy}>
          {showHeader && <Header showSearch={showSearch} />}
          <div className={style.frame} id="scroll-body">
            <Notification
              title={microcopy.text("headers.secondary.notifications.message")}
              href={microcopy.text("headers.secondary.notifications.href")}
              cta={microcopy.text("headers.secondary.notifications.cta")}
              showBanner={microcopy.text("headers.secondary.notifications.display") === "true"}
              visibleTime={parseInt(microcopy.text("headers.secondary.notifications.ttl"))}
            />
            {children}
          </div>
        </MicrocopyProvider>
      </SessionProvider>
    </CookiesProvider>
  </DefaultLayout>
)

export default memo(FramedLayout)
